var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg4Icon32PxBooks(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.97 16.493l-1-3.86-3.15-11.59c-.142-.532-.687-.85-1.22-.71l-3.87 1c-.187-.207-.451-.327-.73-.33H1c-.552 0-1 .448-1 1v16c0 .552.448 1 1 1h10c.552 0 1-.448 1-1v-8l2.2 8.22c.12.45.535.756 1 .74.086.01.174.01.26 0l4.83-1.29c.258-.069.478-.238.61-.47.105-.221.13-.472.07-.71zM5 17H2v-2h3v2zm0-4H2V7h3v6zm0-8H2V3h3v2zm5 12H7v-2h3v2zm0-4H7V7h3v6zm0-8H7V3h3v2zm2.22-1.697l2.9-.78.52 1.93-2.9.78-.52-1.93zm2.59 9.66l-1.55-5.8 2.9-.78 1.55 5.8-2.9.78zm1 3.86l-.52-1.93 2.9-.78.52 1.93-2.9.78z",
    transform: "translate(6 6)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4Icon32PxBooks);
export default __webpack_public_path__ + "static/media/4-icon-32-px-books.ebcd1a26.svg";
export { ForwardRef as ReactComponent };